<template>
  <teleport to="body">
    <notifications
      :class="!isMobile ? 'mb-5 mr-6' : 'mt-1'"
      :position="isMobile ? 'top right' : 'bottom right'"
      :width="isMobile ? '100%' : '320px'"
    >
      <template #body="{ item, close }">
        <div
          :class="themes[item.type]"
          class="notification mx-2 my-1 rounded-2xl bg-opacity-90 px-3 py-6 text-white lg:mx-0 lg:py-4"
        >
          <div class="flex items-center justify-between space-x-3">
            <span class="mr-auto leading-tight">
              {{ $t(item.text) }}
            </span>
            <button
              class="inline-flex flex-shrink-0 focus:outline-none"
              @click="close"
            >
              <img
                alt=""
                height="28"
                loading="lazy"
                src="@/assets/images/base/icons/close-circle-white.svg"
                width="28"
              />
            </button>
          </div>
        </div>
      </template>
    </notifications>
  </teleport>
</template>

<script>
import isMobile from "@/mixins/isMobile.js";

export default {
  name: "LayoutsNotification",
  mixins: [isMobile],
  data() {
    return {
      themes: {
        info: "bg-violet",
        success: "bg-success",
        danger: "bg-error",
      },
    };
  },
};
</script>
